import {Component, Inject} from '@angular/core';
import {LottoPassivoSummaryDto} from '../../../../core/models/fatture.model';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';
@Component({
  selector: 'app-import-lotti-sdi-dialog',
  imports: [
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    CommonModule,
    MatDialogModule,
  ],
  templateUrl: './import-lotti-sdi-dialog.html',
  styleUrl: './import-lotti-sdi-dialog.scss',
})
export class ImportLottiSdiDialogComponent {
  displayedColumns = [
    'select',
    'IdentificativoSdI',
    'IdentificativoPubblicoLotto',
    'Data',
    'DataRicezione',
    'Origine',
  ];

  selection = new SelectionModel<LottoPassivoSummaryDto>(true, []);

  @Inject(MAT_DIALOG_DATA)
  public data: { items: LottoPassivoSummaryDto[] };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: { items: LottoPassivoSummaryDto[] },
    private dialogRef: MatDialogRef<ImportLottiSdiDialogComponent>
  ) {
    this.data = data;
  }

  isAllSelected(): boolean {
    return this.selection.selected.length === this.data.items.length;
  }

  toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.data.items);
  }

  conferma(): void {
    this.dialogRef.close(this.selection.selected);
  }

  annulla(): void {
    this.dialogRef.close(undefined);
  }
}
